/*
    Developer's item info page
*/

import React, { Component } from 'react';
import Dashboard from '../dashboard';
import styles from '../../style/form-card.module.css';
import { connect } from 'react-redux';
import axios from 'axios';
import { Button, InputNumber, Modal, notification, Switch } from 'antd';
import {
  DeleteOutlined,
  EditOutlined,
  RollbackOutlined,
  SaveOutlined,
  UploadOutlined
} from '@ant-design/icons';
import Table from '../table';
import Input from '../input';

class ItemInfoPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allowedResponsesColumns: [
        {
          dataKey: 'score',
          title: 'Score',
          type: 'number'
        },
        {
          dataKey: 'response',
          title: 'Response',
          type: 'input'
        }
      ],
      batteryID: props.match.params.batteryID,
      itemID: props.match.params.itemID,
      testID: props.match.params.testID,
      itemInfo: {
        label: ''
      },
      showAnswerSlideUrl: null,

      // flags
      isEditing: false
    };
  }

  componentDidMount() {
    this.getItemInfo();
  }

  endEditing = () => {
    this.setState({
      isEditing: false
    });

    this.getItemInfo();
  };

  deleteItem = () => {
    return new Promise((resolve, reject) => {
      axios
        .delete(process.env.REACT_APP_API_URL + '/item/delete', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Token ' + this.props.token
          },
          data: {
            itemID: this.state.itemID
          }
        })
        .then((response) => {
          this.props.history.replace(
            `/developer/batteries/${this.state.batteryID}/tests/${this.state.testID}/items`
          );
          resolve();
        })
        .catch((error) => {
          console.log(error);
        });
    }).catch((error) => {
      console.log(error);
    });
  };

  // sends the current state of itemInfo to the API
  editItemInfo = () => {
    const data = {
      itemID: this.state.itemID,
      allowedResponses: this.state.itemInfo.allowedResponses,
      disabled: this.state.itemInfo.disabled,
      isPracticeItem: this.state.itemInfo.isPracticeItem,
      isTeachingItem: this.state.itemInfo.isTeachingItem,
      label: this.state.itemInfo.label,
      requiresDuration: this.state.itemInfo.requiresDuration,
      requiresResponse: this.state.itemInfo.requiresResponse,
      requiresScore: this.state.itemInfo.requiresScore,
      scored: this.state.itemInfo.scored,
      showAnswerEligible: this.state.itemInfo.showAnswerEligible,
      timeLimit: this.state.itemInfo.timeLimit,
      timed: this.state.itemInfo.timed,
      timer_autoStart: this.state.itemInfo.timer_autoStart,
      timer_countdown: this.state.itemInfo.timer_countdown
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.props.token
      }
    };

    return axios
      .post(process.env.REACT_APP_API_URL + '/item/edit', data, config)
      .then((response) => {
        this.endEditing();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getItemInfo = () => {
    const data = {
      itemID: this.state.itemID
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.props.token
      }
    };

    return axios
      .post(process.env.REACT_APP_API_URL + '/item/get', data, config)
      .then((response) => {
        // check to make sure a data object was returned
        if (response.data == null) throw new Error('no response data');

        this.setState({
          itemInfo: {
            allowedResponses: response.data.item.allowedResponses,
            disabled: response.data.item.disabled,
            isPracticeItem: response.data.item.isPracticeItem ?? false,
            isTeachingItem: response.data.item.isTeachingItem ?? false,
            label: response.data.item.label,
            requiresDuration: response.data.item.requiresDuration,
            requiresResponse: response.data.item.requiresResponse,
            requiresScore: response.data.item.requiresScore,
            scored: response.data.item.scored,
            showAnswerEligible: response.data.item.showAnswerEligible,
            timeLimit: response.data.item.timeLimit ?? 60,
            timed: response.data.item.timed,
            timer_autoStart: response.data.item.timer_autoStart,
            timer_countdown: response.data.item.timer_countdown
          }
        });

        this.fetchShowAnswerSlide();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchShowAnswerSlide = () => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.props.token
      }
    };

    axios
      .post(
        process.env.REACT_APP_API_URL + '/item/showAnswerGet',
        { itemID: this.state.itemID },
        config
      )
      .then((response) => {
        this.setState({ showAnswerSlideUrl: response.data.url });
      })
      .catch(() => {
        this.setState({ showAnswerSlideUrl: null });
      });
  };

  uploadShowAnswerSlide = (file) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.props.token
      }
    };

    axios
      .post(
        process.env.REACT_APP_API_URL + '/item/showAnswerUpload',
        { itemID: this.state.itemID, fileName: file.name },
        config
      )
      .then((response) => {
        const formData = new FormData();
        Object.entries(response.data.fields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('Content-Type', file.type);
        formData.append('file', file);

        return axios.post(response.data.url, formData);
      })
      .then(() => {
        notification.success({ message: 'Show Answer slide uploaded' });
        this.fetchShowAnswerSlide();
      })
      .catch((error) => {
        notification.error({ message: 'Failed to upload Show Answer slide' });
        console.log(error);
      });
  };

  handleItemInfoChange = (event) => {
    const { name, value } = event.target;

    this.setState((state) => ({
      itemInfo: {
        ...state.itemInfo,
        [name]: value
      }
    }));
  };

  handleItemSwitchChange = (checked, name) => {
    this.setState((state) => {
      const updated = { ...state.itemInfo, [name]: checked };
      if (name === 'timed' && checked && !state.itemInfo.timeLimit) {
        updated.timeLimit = 60;
      }
      if (checked && name === 'isTeachingItem') {
        updated.isPracticeItem = false;
      }
      if (checked && name === 'isPracticeItem') {
        updated.isTeachingItem = false;
      }
      return { itemInfo: updated };
    });
  };

  renderSwitch = (label, name) => {
    return (
      <div className={`${styles['item-container']} ${styles['item-switch']}`}>
        <label className={styles['item-name']}>{label}</label>
        <Switch
          aria-label={label}
          disabled={!this.state.isEditing}
          onChange={(checked) => this.handleItemSwitchChange(checked, name)}
          readOnly={!this.state.isEditing}
          checked={this.state.itemInfo[name]}
        />
      </div>
    );
  };

  showDeleteConfirm = () => {
    let deleteItem = this.deleteItem;
    Modal.confirm({
      cancelText: 'Cancel',
      content: 'This can not be undone!',
      okButtonProps: { type: 'danger' },
      okText: 'Delete',
      onCancel() {},
      onOk() {
        deleteItem();
      },
      title: 'Are you sure you want to delete this item?'
    });
  };

  allowedResponseDataCreateNewRow = () => {
    let newAllowedResponses = this.state.itemInfo.allowedResponses || [];
    newAllowedResponses.push({
      response: '',
      score: 0
    });
    this.setState({
      itemInfo: {
        ...this.state.itemInfo,
        allowedResponses: newAllowedResponses
      }
    });
  };

  allowedResponseDataDidChange = (newData) => {
    this.setState({
      itemInfo: {
        ...this.state.itemInfo,
        allowedResponses: newData
      }
    });
  };

  allowedResponseDataDeleteRow = (rowIndex) => {
    let newData = this.state.itemInfo.allowedResponses;
    newData.splice(rowIndex, 1);
    this.setState({
      itemInfo: {
        ...this.state.itemInfo,
        allowedResponses: newData
      }
    });
  };

  render() {
    return (
      <Dashboard>
        <div className={styles['card']}>
          <div className={styles['header']}>
            <label className={styles['name']}>
              {this.state.itemInfo.label ? this.state.itemInfo.label : null}
            </label>
            {
              // cancel button
              this.state.isEditing ? (
                <div className={styles['button-container']} onClick={this.endEditing}>
                  <RollbackOutlined />
                  <label className={styles['header-button-label']}>cancel</label>
                </div>
              ) : null
            }
            {
              // save button
              this.state.isEditing ? (
                <div className={styles['button-container']} onClick={this.editItemInfo}>
                  <SaveOutlined />
                  <label className={styles['header-button-label']}>Save</label>
                </div>
              ) : null
            }
            {
              // delete button
              !this.state.isEditing ? (
                <div
                  className={styles['button-container']}
                  onClick={() => this.showDeleteConfirm()}
                >
                  <DeleteOutlined />
                  <label className={styles['header-button-label']}>Delete</label>
                </div>
              ) : null
            }
            {
              // edit button
              !this.state.isEditing ? (
                <div
                  className={styles['button-container']}
                  onClick={() =>
                    this.setState({
                      isEditing: true
                    })
                  }
                >
                  <EditOutlined />
                  <label className={styles['header-button-label']}>Edit</label>
                </div>
              ) : null
            }
          </div>
          <hr className={styles['horizontal-line']}></hr>
          <div className={styles['info-container']}>
            <div className={styles['item-container']}>
              <label className={styles['item-name']}>Label</label>
              <Input
                className={styles['item-string']}
                disabled={!this.state.isEditing}
                name="label"
                onChange={this.handleItemInfoChange}
                onPressEnter={(e) => e.target.blur()}
                value={this.state.itemInfo.label}
              />
              <hr className={styles['item-underline']}></hr>
            </div>
            <div className={styles['field-row']}>
              {this.renderSwitch('Disabled', 'disabled')}
              {this.renderSwitch('Scored', 'scored')}
              {this.renderSwitch('Teaching item', 'isTeachingItem')}
              {this.renderSwitch('Practice item', 'isPracticeItem')}
            </div>
            <div className={styles['field-row']}>
              {this.renderSwitch('Timed', 'timed')}
              {this.renderSwitch('Reverse timer', 'timer_countdown')}
              {this.renderSwitch('Auto-start timer', 'timer_autoStart')}
              {this.state.itemInfo.timed && (
                <div className={styles['item-container']}>
                  <label className={styles['item-name']}>Time Limit (seconds)</label>
                  <InputNumber
                    className={styles['item-number']}
                    disabled={!this.state.isEditing}
                    min={0}
                    onChange={(value) =>
                      this.setState((state) => ({
                        itemInfo: { ...state.itemInfo, timeLimit: value }
                      }))
                    }
                    value={this.state.itemInfo.timeLimit}
                  />
                </div>
              )}
            </div>
            <div className={styles['field-row']}>
              {this.renderSwitch('Requires Duration', 'requiresDuration')}
              {this.renderSwitch('Requires Response', 'requiresResponse')}
              {this.renderSwitch('Requires Score', 'requiresScore')}
            </div>
            <div className={styles['field-row']}>
              {this.renderSwitch('Show Answer Eligible', 'showAnswerEligible')}
              {this.state.itemInfo.showAnswerEligible && (
                <div className={styles['item-container']}>
                  <label className={styles['item-name']}>Show Answer Slide</label>
                  {this.state.isEditing && (
                    <Button
                      icon={<UploadOutlined />}
                      onClick={() => this.fileInputRef && this.fileInputRef.click()}
                    >
                      Upload Slide
                    </Button>
                  )}
                  <input
                    accept="image/*"
                    onChange={(e) => {
                      if (e.target.files && e.target.files[0]) {
                        this.uploadShowAnswerSlide(e.target.files[0]);
                        e.target.value = '';
                      }
                    }}
                    ref={(ref) => (this.fileInputRef = ref)}
                    style={{ display: 'none' }}
                    type="file"
                  />
                  {this.state.showAnswerSlideUrl ? (
                    <img
                      alt="Show Answer slide preview"
                      src={this.state.showAnswerSlideUrl}
                      style={{
                        border: '1px solid #e8e8e8',
                        borderRadius: 4,
                        marginTop: 8,
                        maxWidth: 200,
                        objectFit: 'contain'
                      }}
                    />
                  ) : (
                    <span style={{ color: '#8c8c8c', fontSize: '0.8125rem', marginTop: 8 }}>
                      No slide uploaded
                    </span>
                  )}
                </div>
              )}
            </div>
            <div className={styles['item-container-wide']}>
              <label className={styles['item-name']}>Allowed Responses</label>
              <Table
                columns={this.state.allowedResponsesColumns}
                createNewRow={this.allowedResponseDataCreateNewRow}
                data={this.state.itemInfo.allowedResponses}
                dataDidChange={this.allowedResponseDataDidChange}
                deleteRow={this.allowedResponseDataDeleteRow}
                isEditing={this.state.isEditing}
              />
            </div>
          </div>
        </div>
      </Dashboard>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.token
});

export default connect(mapStateToProps, null)(ItemInfoPage);
